import React from "react";
import { Footer } from "@bloomberg/media-ui-nav/client";
import { addPrivacyManager } from "../../utils/addPrivacyManager";
import { IntlProvider } from "react-intl";
import { onLocaleError } from "../../lang/errorHandler";
import { RoutePathLocale, RoutePathLocaleValue } from "../../lang/i18n";

export default function FooterComponent({
    translatedMessages,
    locale = RoutePathLocale.en,
}: {
    translatedMessages?: Record<string, string>;
    locale?: RoutePathLocaleValue;
}) {
    return (
        <div className="footer">
            <IntlProvider
                locale={locale}
                defaultLocale={RoutePathLocale.en}
                messages={translatedMessages}
                onError={onLocaleError}
            >
                <Footer
                    desktopBreakpointClassName="bb-desktop-new-footer"
                    addPrivacyManager={addPrivacyManager}
                    showLogo={false}
                />
            </IntlProvider>
        </div>
    );
}
